import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import pushDataLayer from '@app/libs/analytics/googleTagManager';
import { createDraft, CreateDraftRequest } from '@app/store/transport-layer/form/drafts';

export default function useCreateDraft(
  options?: UseMutationOptions<
    {
      id: string;
      name: string;
      content: string;
      createdAt: string;
      updatedAt: string;
    },
    Error,
    { workspaceId: string; data: CreateDraftRequest }
  >
) {
  const queryClient = useQueryClient();

  return useMutation(({ workspaceId, data }) => createDraft(workspaceId, data), {
    ...options,
    onSuccess: (data, variables, ctx) => {
      queryClient.setQueryData(['draft', data.id], {
        id: data.id,
        name: data.name,
        content: data.content,
      });
      options?.onSuccess?.(data, variables, ctx);
      pushDataLayer({ event: 'createDraft', form: { id: data.sourceFormId } });
    },
  });
}
